<template>
<div :style="'background:#eee;overflow: hidden;height:' + clientHeight +'px'">
    <div ref="head">
    <Card :padding="0" style="margin-bottom: 5px;" dis-hover>
        <Row type="flex" justify="start" align="middle" style="padding:5px 10px">
            <Col span ='18'>
                <Row type="flex" justify="start" align="middle">
                    <ButtonToolBar  ref="menutoolbar" :config="menuToolbar"  :moduleMethod="moduleMethod"  @doAction="doAction"/>
                </Row>
            </Col>
            <Col span ='6'>
                <Row type="flex" justify="end" align="middle">
                    <PromptMessage/>
                </Row>
            </Col>
        </Row>
    </Card>
    </div>
    <div>
    <Row type="flex" justify="start">
            <Col :span="myConfig.gridCol" style="background:#eee;padding-right: 5px">
                <Card :padding="0" :bordered="false">
                    <div style="padding-top:8px;padding-bottom:12px">
                        <div ref="para">
                        <Row  type="flex" justify="start" align="middle" style="margin-bottom: 8px">
                            <Col span= '21' style="margin-left:30px">
                                <QuickQueryToolbar ref="quick"  :config="myConfig.quickQueryConfig" :dictData="dictData" @on-change="quickChagne" :singleMode="true" :filter="false"/>
                            </Col>
                        </Row>
                        </div>
                        <TreeBox v-show="showTree" ref="tree" :config="myConfig.treeConfig"   @onSelectChange="selectChange" style="padding-left:30px;"/>
                        <ViewGrid  v-show="!showTree"  ref="grid" :config="myConfig.gridConfig" :dictData="dictData" @click="gridClick"/>
                    </div>
                </Card>
            </Col>
            <Col :span="myConfig.formCol" style="background:#eee;">
                <Card :padding="0" :bordered="false"   dis-hover>
                <div style="background:#eee;">
                    <div ref="title">
                    <Card  v-if="myConfig.showLevelTitle" :padding="12"  dis-hover style="margin-bottom: 8px" >
                        <Breadcrumb style="margin-left:20px">
                            <BreadcrumbItem v-for="(temp,index) in levelData" to="click" :key="index" @click="levelClik(temp)">{{temp.name}}</BreadcrumbItem>
                        </Breadcrumb>
                    </Card>
                    </div>
                    <BillDetailForm ref="form" :config="myConfig.detailConfig" :dictData="dictData"/>
                </div>
                </Card>
            </Col>
    </Row>
    </div>
</div>
</template>

<script>
import QuickQueryToolbar from './quickquerytoolbar.vue';
import PromptMessage from './promptmessage.vue';
import elementResizeDetectorMaker from 'element-resize-detector';
export default {
    name:'lefttreerightdetails',
    components:{QuickQueryToolbar,PromptMessage},
    data () {
        return {
            myConfig:{
                showOperLog:false,
                operLogKey:'billno',
                bindingKey:'ph_key',
                resources:'',
                className:'',
                gridCol:8,
                formCol:16,
                formTitle:'详情',
                adjustHeight:200,
                treeConfig:{},
                gridConfig:{},
                quickQueryConfig:{},
                showLevelTitle:true
            },
            rootNode:{},
            levelData:[],
            menuToolbar:{
                enablePermissions:true,
                items:[ {
                    text: '新增本项',
                    name: 'addData',
                },
                {
                    text: '新增子项',
                    name: 'addChildData',
                },{
                    name:'editData',
                    text:'编辑'
                },{
                    name:'saveData',
                    text:'保存'
                },{
                    name:'delData',
                    text:'删除'
                }]
            },
            showTree:true,
            ph_key:'',
            treeSeletedNode:[]
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        }
    },
    computed: {
        clientHeight () {
            return this.$Store.state.app.clientHeight;
        }
    },
    created () {
        this.myConfig =  Object.assign({},this.myConfig, this.config);
        this.myConfig.gridConfig.headStyle='';
        this.myConfig.gridConfig.onSelectionChange = this.gridOnSelectionChange;
        this.myConfig.gridConfig.overrideData = this.gridOverrideData;
        this.myConfig.gridConfig.showCondition = false;
        this.myConfig.gridConfig.resources = this.myConfig.resources;
        this.myConfig.gridConfig.method = this.myConfig.classPrefix + '.search';
        this.myConfig.gridConfig.response = this.myConfig.response;
        this.myConfig.gridConfig.tableSize ='small';
        this.myConfig.gridConfig.showBorder = false;
        this.myConfig.gridConfig.pageShowSizer = false;
        this.myConfig.gridConfig.height = 1;
        this.myConfig.gridConfig.adjustHeight = 0;
        this.myConfig.quickQueryConfig.fuzzyQueryStyle = 'width:100%';
        this.myConfig.gridConfig.multiSelect = false;
        if (this.myConfig.treeConfig.items) {
            this.myConfig.gridConfig.items = this.$Method.copy(this.myConfig.treeConfig.items);
        }
        if (this.myConfig.treeConfig.searchParam) {
            this.myConfig.gridConfig.searchParam = {};
            Object.assign(this.myConfig.gridConfig.searchParam, this.myConfig.treeConfig.searchParam);
        }


        // 处理树
        this.myConfig.treeConfig.resources = this.myConfig.resources;
        if (!this.myConfig.treeConfig.method) {
            this.myConfig.treeConfig.method = this.myConfig.classPrefix + '.search';
        }
        if (!this.myConfig.treeConfig.response) {
            this.myConfig.treeConfig.response = this.myConfig.response;
        }
        this.myConfig.treeConfig.showCondition = false;
        this.myConfig.treeConfig.showTitle = false;
        this.myConfig.treeConfig.bordered = false;
        this.myConfig.treeConfig.disHover = true;
        this.myConfig.treeConfig.height = 1;
        this.myConfig.treeConfig.adjustHeight =  0;
        this.myConfig.treeConfig.selectedRoot = true;

        // 处理按钮
        if (this.myConfig.menuToolbar !== undefined) {
            Object.keys(this.myConfig.menuToolbar).forEach(pro => {
                if (pro === 'items') {
                    if (this.myConfig.menuToolbar[pro].length > 0) {
                        this.menuToolbar[pro] = this.$Method.copy(this.myConfig.menuToolbar[pro]);
                    }
                    this.menuToolbar[pro].forEach(el => {
                        el.readOnly = true;
                    });
                } else {
                    this.menuToolbar[pro] = this.myConfig.menuToolbar[pro];
                }
            });
        }
        this.myConfig.detailConfig.titleType = 2;
        this.myConfig.detailConfig.showMenuToolbar = false;
        this.myConfig.detailConfig.showBillTitle = false;
        this.myConfig.detailConfig.response = this.myConfig.response;
        this.myConfig.detailConfig.adjustHeight = 0;
        // 处理日志
        if (this.myConfig.showOperLog) {
            this.myConfig.detailConfig.showOperLog = true;
            if (this.myConfig.operLogKey) {
                this.myConfig.detailConfig.operLogKey = this.myConfig.operLogKey;
            }
        }
        this.myConfig.detailConfig.resources = this.myConfig.resources; 
    },
    methods:{
        levelClik(temp) {
            let last = this.levelData.length - 1;
            let index = this.levelData.findIndex(el => el.code === temp.code);
            if (last === index) {
                return false;
            }
            if (index > -1) {
                this.levelData.splice(last, last - index);
            }
            this.selectLevel(temp);
        },
        selectLevel(temp) {
            this.showTree = true;
            this.treeSeletedNode = [temp.node];
            this.initTree();
            this.initForm(temp.node);
            this.$refs.quick.clearData();
            if (this.$refs.tree.isChildren(temp.node)) {
                this.$refs.menutoolbar.setReadOnly(['addData','addChildData','editData'], false);
            } else {
                this.$refs.menutoolbar.setReadOnly(['addData','addChildData','editData','delData'], false);
            }
        },
        selectChange (e) {
            let obj = {};
            let self = this;
            obj.onOk = () => {    
                if (e && e.length > 0) {
                    self.$refs.menutoolbar.setAllReadOnly(true);
                    self.treeSeletedNode = self.$Method.copy(e);
                    self.initForm(e[0]);
                } else {
                    self.doCanCel();
                }
            };
            obj.onCancel = () => {
                self.doCanCel();
            };
            this.checkData(obj);
        },
        search () {
            let obj = this.getSearchParam();
            this.treeSeletedNode = [];
            if (JSON.stringify(obj) === '{}') {
                this.initTree();
                this.showTree = true;
            } else {
                this.$refs.grid.clearSearchBeforeSearchParam();
                this.$refs.grid.setSearchBeforeSearchParam(obj);
                this.$refs.grid.refurbish();
                this.showTree = false;
            }
        },
        initLevel (node) {
            if (JSON.stringify(node) === '{}') {
                return false;
            }
            this.levelData = [];
            let rootNode = this.$refs.tree.getRootNode();
            // eslint-disable-next-line no-constant-condition
            do {
                let culNodeKey = node[this.myConfig.treeConfig.idField];
                let temp = {};
                if (culNodeKey === rootNode[this.myConfig.treeConfig.idField]) {
                    temp.name = rootNode[this.myConfig.treeConfig.responseName];
                    temp.code  = culNodeKey;
                    temp.node = this.$Method.copy(rootNode);
                    if (this.$parent.setLevelInfo) {
                        temp = this.$parent.setLevelInfo(temp);
                    }
                    this.levelData.push(temp);
                    break;
                } else {
                    temp.name =  node[this.myConfig.treeConfig.responseName];
                    temp.code  = culNodeKey;
                    temp.node = this.$Method.copy(node);
                    if (this.$parent.setLevelInfo) {
                        temp = this.$parent.setLevelInfo(temp);
                    }
                    this.levelData.push(temp);
                    if (node[this.myConfig.treeConfig.parentField] === rootNode[this.myConfig.treeConfig.idField]) {
                        let root = {};
                        root.name =  rootNode[this.myConfig.treeConfig.responseName];
                        root.code  = culNodeKey;
                        root.node = this.$Method.copy(rootNode);
                        if (this.$parent.setLevelInfo) {
                            root = this.$parent.setLevelInfo(temp);
                        }
                        this.levelData.push(root);
                        break;
                    } else {
                        node = this.$refs.tree.getFatherNode(temp.node);
                        if (JSON.stringify(node) === '{}') {
                            break;
                        }
                    }     
                }
            } while (true);
            this.levelData.reverse();
        },
        getSearchParam () {
            return this.$refs.quick.getData();
        },
        refurbish () {
            this.treeSeletedNode = [];
            this.initTree();
        },
        gridOnSelectionChange(rows) {
            let obj = {};
            obj.name = 'gridOnSelectionChange';
            obj.para = rows;
            this.$emit('doAction', obj);
        },
        gridOverrideData (data) {
            if (data && data.length > 0) {
                let self = this;
                this.$nextTick(() => {
                    let index = 0;
                    if (self.treeSeletedNode.length > 0) {
                        let culIndex = data.findIndex(el => el[self.myConfig.bindingKey]=== self.treeSeletedNode[0][self.myConfig.bindingKey]);
                        if (culIndex > -1) {
                            index = culIndex;
                        }
                    }
                    self.$refs.grid.setRowHighlight(index,true);
                    self.ph_key = data[index].ph_key;
                    self.initForm(data[index]);
                    self.$refs.form.setReadOnly(true);
                    self.$refs.menutoolbar.setAllReadOnly(false);
                    self.$refs.menutoolbar.setReadOnly('saveData', true);
                });
            } else {
                this.$refs.form.clearData();
                this.$refs.form.setReadOnly(true);
                this.$refs.menutoolbar.setAllReadOnly(true);
                this.$refs.menutoolbar.setReadOnly('addData', true);
            }
           
            return data;
        },
        gridClick(e) {
            let obj = {};
            let self = this;
            obj.onOk = () => {
                self.treeSeletedNode = [e];
                self.initForm(e);
            };
            obj.onCancel = () => {
                self.doCanCel();
            };
            this.checkData(obj);
        },
        doCanCel () {
            this.$nextTick(() => {
                if (this.showTree) {
                    this.$refs.tree.setData(this.treeSeletedNode);
                } else {
                    this.$refs.grid.setAllRowHighlight(false);
                    let data = self.$refs.grid.getData();
                    let index = data.findIndex(el => el[self.myConfig.bindingKey] === self.treeSeletedNode[0][self.myConfig.bindingKey]);
                    if (index > -1) {
                        this.$refs.grid.setRowHighlight(index, true);
                    } else {
                        this.$refs.grid.clearCurrentRow();
                    }
                }
            });

        },
        getForm() {
            return this.$refs.form;
        },
        getGrid() {
            return this.$refs.grid;
        },
        getTree() {
            return this.$refs.tree;
        },
        getMenuToolbar() {
            return this.$refs.menutoolbar;
        },
        quickChagne () {
            this.search();
        },
        initTree(flag) {
            this.$refs.tree.refurbish();
            this.$nextTick(() => {
                if (this.treeSeletedNode.length > 0) {
                    this.$refs.tree.setData(this.treeSeletedNode);
                }  else {
                    this.treeSeletedNode.push(this.$refs.tree.getRootNode());
                }
                if (!flag) {
                    this.initForm(this.treeSeletedNode[0]);
                }
            });
        },
        initForm (para) {
            this.$refs.form.clearData();
            let data = {};
            this.$refs.menutoolbar.setAllReadOnly(true);
            let rootNode = this.$refs.tree.getRootNode();
            if (para[this.myConfig.treeConfig.idField]  === rootNode[this.myConfig.treeConfig.idField]) {
                this.$refs.menutoolbar.setReadOnly('addChildData', false);
                data = this.$Method.copy(rootNode);
            } else {
                data = this.getFormData(para);
                if (this.$refs.tree.isChildren(para)) {
                    this.$refs.menutoolbar.setReadOnly(['addData','addChildData','editData'], false);
                } else {
                    this.$refs.menutoolbar.setReadOnly(['addData','addChildData','editData','delData'], false);
                }
            }
            if (this.$parent.setBillData) {
                data = this.$parent.setBillData(data);
            }
            this.$refs.form.setData(data); 
            this.$nextTick(() => {
                this.$refs.form.setReadOnly(true);
            });
            this.initLevel(data);
            if (this.$parent.initFormAfter) {
                this.$parent.initFormAfter(data);
            }
        },
        getFormData (para) {
            if (this.$parent.getFormData) {
                return this.$parent.getFormData(para);
            } else {
                let result = {};
                let self = this;
                if (!para.ph_key) {
                    para.ph_key = this.ph_key;
                }
                self.synchroPost(self.myConfig.resources,self.myConfig.classPrefix+'.get', {ph_key:para.ph_key}, function (data) {
                    result = data[self.config.response];
                });
                return result;
            }
        },
        doAction(obj) {
            const method = obj.name;
            const methodBefore = method + 'Before';
            const methodAfter = method + 'After';
            if (obj.name === 'addData' || obj.name === 'addChildData' || obj.name === 'editData' ) {
                let flag =  true;
                let temp = {};
                if (this.$parent[methodBefore]) {
                    flag = this.$parent[methodBefore](temp);
                }
                if (flag) {
                    if (obj.name === 'addData' || obj.name === 'addChildData') {
                        this.$refs.form.setReadOnly(false);
                        this.$refs.form.clearData();
                        this.$refs.form.setData(temp);
                        this.$refs.menutoolbar.setAllReadOnly(true);
                        this.$refs.menutoolbar.setReadOnly('saveData', false);
                    }
                    if (obj.name === 'editData') {
                        this.$refs.form.setReadOnly(false);
                        this.$refs.menutoolbar.setReadOnly('editData', true);
                        this.$refs.menutoolbar.setReadOnly('saveData', false);
                    }
                     
                    if (this.$parent[methodAfter]) {
                        this.$parent[methodAfter]();
                    }
                }
            } else {
                if (obj.name === 'saveData') {
                    let flag = this.$refs.form.checkValidate();
                    if (flag) {
                        this.alert('必填项不允许为空');
                        return false;
                    }
                    flag = this.$refs.form.isEdit();
                    if (flag) {
                        this.alert('存在数据未确认');
                        return false; 
                    }
                    let data = this.$refs.form.getChangeData();
                    obj.para = [];
                    obj.para.push(data);
                    
                }
                if (obj.name === 'delData') {
                    let tempData = this.$refs.form.getData();
                    tempData.flag = 'D';
                    obj.para = tempData;
                }
                obj.onOk = this.onOk;
                if (obj.name === 'delData') {
                    let self = this;
                    self.$Modal.confirm({
                        title:'确认',
                        content:'是否确认删除？',
                        onOk:() => {
                            self.$emit('doAction', obj);
                        }
                    });
                } else {
                    this.$emit('doAction', obj);
                }
            }
        },
        onOk (action, data) {
            if (action.name === 'saveData') {
                this.$refs.menutoolbar.setAllReadOnly(true);
                this.initForm(data[0]);
                this.$refs.form.setReadOnly(true);
                let temp = this.$refs.form.getData();
                this.treeSeletedNode =[temp];
                this.initTree(true);
                if (!this.showTree) {
                    this.$refs.grid.refurbish();
                }
                this.$refs.menutoolbar.setReadOnly(['addData','addChildData','editData'], false);
            }
            if (action.name === 'delData') {
                this.$nextTick(() =>{
                    this.levelData.splice(this.levelData.length - 1, 1);
                    this.selectLevel(this.levelData[this.levelData.length - 1]);
                });
            }
        },
        checkData (obj) {
            let tempflag = false;
            tempflag = this.$refs.form.isEdit();
            if (tempflag) {
                let self = this;
                self.$Modal.confirm({
                    title:'确认',
                    content:'单据存在数据未确认，是否放弃？',
                    onOk:() => {
                        this.checkChangeData(obj);
                    },
                    onCancel:() => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                this.checkChangeData(obj);
            }
        },
        checkChangeData(obj) {
            let flag = false;
            flag = this.$refs.form.isChange();
            if (flag) {
                let self = this;
                self.$Modal.confirm({
                    title:'确认',
                    content:'单据有修改未保存，是否放弃修改？',
                    onOk:() => {
                        if (obj.onOk) {
                            obj.onOk();
                        }
                    },
                    onCancel:() => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                if (obj.onOk) {
                    obj.onOk();
                }
            }
        },
        setTreeAndGridAndFormHeight() {
            let height = this.$refs.head.offsetHeight + this.$refs.para.offsetHeight + 32;
            this.$refs.tree.setOutsideHeight(height);
            this.$refs.grid.setOutsideHeight(height);
            let height2 = this.$refs.head.offsetHeight + this.$refs.title.offsetHeight + 8;
            this.$refs.form.setOutsideHeight(height2);
        }
    },
    mounted () {
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.head, this.setTreeAndGridAndFormHeight);
        this.observer.listenTo(this.$refs.page, this.setTreeAndGridAndFormHeight);
        this.observer.listenTo(this.$refs.title, this.setTreeAndGridAndFormHeight);
        this.$nextTick(() => {
            this.$refs.form.setReadOnly(true);
        });
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.head, this.setTreeAndGridAndFormHeight);
        this.observer.removeListener(this.$refs.page, this.setTreeAndGridAndFormHeight);
        this.observer.removeListener(this.$refs.title, this.setTreeAndGridAndFormHeight);
    }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layouttemplate/lefttreerightdetails.vue